/**
 * Serviço de pagamento com Mercado Pago
 * Versão com API real em modo sandbox
 */

/**
 * Cria uma preferência de pagamento via backend (Supabase Edge Function)
 * @param {Object} userData - Dados do usuário
 * @param {string} userData.userId - ID do usuário
 * @param {string} userData.email - Email do usuário
 * @param {string} userData.name - Nome do usuário
 * @returns {Promise<Object>} - Resposta da preferência criada
 */
export const createPaymentPreference = async (userData) => {
  try {
    console.log('Criando preferência de pagamento para:', userData);
    
    // Chamada para nosso backend (Supabase Edge Function)
    const response = await fetch('https://qafhpvkzzpfouhaclykh.supabase.co/functions/v1/mercadopago-checkout', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${import.meta.env.VITE_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InFhZmhwdmt6enBmb3VoYWNseWtoIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTQ2ODk4MzYsImV4cCI6MjA3MDI2NTgzNn0.Uzg9BdcmdRzyDKappcPeZ7VQLTgdBZmUgkKvKMrp_J8'}`
      },
      body: JSON.stringify({
        user_id: userData.userId,
        email: userData.email,
        name: userData.name
      })
    });

    if (!response.ok) {
      const errorData = await response.text();
      console.error('Erro do backend:', errorData);
      throw new Error(`Erro no backend: ${response.status} - ${errorData}`);
    }

    const data = await response.json();
    
    if (!data.success) {
      throw new Error(data.error || 'Erro ao criar preferência');
    }
    
    console.log('Preferência criada com sucesso:', data);
    
    return {
      success: true,
      preferenceId: data.preference_id,
      initPoint: data.url,
      sandboxInitPoint: data.url // Em produção, ambos são iguais
    };
    
  } catch (error) {
    console.error('Erro ao criar preferência de pagamento:', error);
    
    return {
      success: false,
      error: error.message || 'Erro desconhecido ao criar pagamento'
    };
  }
};

/**
 * Redireciona para o checkout do Mercado Pago
 * @param {string} initPoint - URL do checkout
 */
export const redirectToCheckout = (initPoint) => {
  if (initPoint) {
    console.log('Redirecionando para Mercado Pago:', initPoint);
    // Redirecionamento real para o Mercado Pago (PRODUÇÃO)
    window.location.href = initPoint;
  } else {
    console.error('URL de checkout não disponível');
  }
};

/**
 * Verifica o status de um pagamento
 * @param {string} paymentId - ID do pagamento
 * @returns {Promise<Object>} - Status do pagamento
 */
export const getPaymentStatus = async (paymentId) => {
  try {
    console.log('Verificando status do pagamento:', paymentId);
    
    // Chamada real para a API do Mercado Pago
    const response = await fetch(`https://api.mercadopago.com/v1/payments/${paymentId}`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${import.meta.env.VITE_MERCADOPAGO_ACCESS_TOKEN || 'APP_USR-3615920759469093-092310-4da25ef21d645f681f4c3a382a32f0bc-2704066167'}`,
        'Content-Type': 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error(`Erro na API do Mercado Pago: ${response.status}`);
    }

    const data = await response.json();
    
    return {
      success: true,
      status: data.status,
      paymentId: paymentId,
      data: data
    };
    
  } catch (error) {
    console.error('Erro ao verificar status do pagamento:', error);
    return {
      success: false,
      error: error.message
    };
  }
};

/**
 * Processa webhook do Mercado Pago
 * @param {Object} webhookData - Dados do webhook
 * @returns {Object} - Resultado do processamento
 */
export const processWebhook = (webhookData) => {
  try {
    console.log('Processando webhook do Mercado Pago:', webhookData);
    
    return {
      success: true,
      message: 'Webhook processado com sucesso'
    };
    
  } catch (error) {
    console.error('Erro ao processar webhook:', error);
    return {
      success: false,
      error: error.message
    };
  }
};